// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SocialAccounts admin page styles */

.social-accounts-page {
    padding: 0;
}

/* ── Header ── */
.sa-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.sa-header h1 {
    margin: 0;
}

.sa-btn-refresh {
    padding: 0.5rem 1rem;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
    transition: background 0.15s;
}

.sa-btn-refresh:hover {
    background: #f1f5f9;
}

/* ── Platform Tabs ── */
.sa-platform-tabs {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.25rem;
    border-bottom: 2px solid #e2e8f0;
    padding-bottom: 0;
}

.sa-platform-tab {
    padding: 0.6rem 1.25rem;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    color: #64748b;
    border-bottom: 2px solid transparent;
    margin-bottom: -2px;
    transition: color 0.15s, border-color 0.15s;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.sa-platform-tab:hover {
    color: #1e293b;
}

.sa-platform-tab-active {
    color: #3b82f6;
    border-bottom-color: #3b82f6;
    font-weight: 600;
}

.sa-tab-count {
    background: #f1f5f9;
    color: #475569;
    font-size: 0.75rem;
    padding: 0.1rem 0.5rem;
    border-radius: 10px;
    font-weight: 600;
}

.sa-platform-tab-active .sa-tab-count {
    background: #dbeafe;
    color: #2563eb;
}

/* ── Stats row ── */
.sa-stats-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.sa-stat-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 1.25rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.sa-stat-value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #1e293b;
}

.sa-stat-label {
    font-size: 0.8rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.sa-stat-active .sa-stat-value {
    color: #16a34a;
}

.sa-stat-expired .sa-stat-value {
    color: #dc2626;
}

.sa-stat-notoken .sa-stat-value {
    color: #94a3b8;
}

/* ── Filters ── */
.sa-filters {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
}

.sa-search-input {
    flex: 1 1;
    min-width: 200px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 0.9rem;
}

.sa-search-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, .15);
}

.sa-select {
    padding: 0.5rem 0.75rem;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 0.9rem;
    background: #fff;
    min-width: 150px;
}

/* ── Table ── */
.sa-table-container {
    background: #fff;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
}

.sa-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
}

.sa-table thead th {
    text-align: left;
    padding: 0.75rem 1rem;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    color: #475569;
    font-weight: 600;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    white-space: nowrap;
}

.sa-table tbody td {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
}

.sa-row-clickable {
    cursor: pointer;
    transition: background 0.12s;
}

.sa-row-clickable:hover {
    background: #f8fafc;
}

.sa-user-email {
    font-size: 0.85rem;
    color: #475569;
}

.sa-username-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.sa-profile-pic {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
}

.sa-avatar-fallback {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
    flex-shrink: 0;
}

.sa-detail-avatar-fallback {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 700;
    flex-shrink: 0;
    border: 2px solid #e2e8f0;
}

.sa-hidden {
    display: none !important;
}

/* ── Badges ── */
.sa-badge {
    display: inline-block;
    padding: 0.2rem 0.6rem;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
}

.sa-badge-connected {
    background: #d1fae5;
    color: #065f46;
}

.sa-badge-expired {
    background: #fee2e2;
    color: #991b1b;
}

.sa-badge-notoken {
    background: #f1f5f9;
    color: #64748b;
}

/* ── Pagination ── */
.sa-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1.25rem;
}

.sa-pagination button {
    padding: 0.4rem 0.9rem;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
}

.sa-pagination button:disabled {
    opacity: 0.45;
    cursor: default;
}

.sa-page-info {
    font-size: 0.85rem;
    color: #64748b;
}

/* ── States ── */
.sa-loading,
.sa-empty {
    text-align: center;
    padding: 3rem 1rem;
    color: #64748b;
    font-size: 0.95rem;
}

.sa-error {
    background: #fef2f2;
    color: #b91c1c;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
    font-size: 0.9rem;
}

/* ── Detail Modal ── */
.sa-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 1rem;
}

.sa-modal-card {
    background: #fff;
    border-radius: 12px;
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.sa-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #e2e8f0;
}

.sa-modal-header h2 {
    margin: 0;
    font-size: 1.1rem;
}

.sa-modal-close {
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    color: #64748b;
    padding: 0.25rem;
}

.sa-modal-body {
    padding: 1.5rem;
}

.sa-detail-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.sa-detail-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #e2e8f0;
}

.sa-detail-row h3 {
    margin: 0;
}

.sa-detail-name {
    margin: 0.25rem 0 0;
    color: #64748b;
    font-size: 0.9rem;
}

.sa-detail-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.sa-detail-item {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
}

.sa-detail-item label {
    font-size: 0.75rem;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.sa-detail-item span {
    font-size: 0.9rem;
    color: #1e293b;
}

/* ── Responsive ── */
@media (max-width: 768px) {
    .sa-stats-row {
        grid-template-columns: repeat(2, 1fr);
    }

    .sa-detail-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 480px) {
    .sa-stats-row {
        grid-template-columns: 1fr;
    }

    .sa-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }

    .sa-platform-tabs {
        overflow-x: auto;
    }
}

/* ── TikTok Detail extras ── */
.sa-mono {
    font-family: 'SF Mono', 'Fira Code', monospace;
    font-size: 0.8rem;
    word-break: break-all;
}

.sa-detail-full-width {
    grid-column: 1 / -1;
}

.sa-tiktok-link {
    color: #3b82f6;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
}

.sa-tiktok-link:hover {
    text-decoration: underline;
}

/* Business API section header in TikTok detail */
.sa-detail-section-header {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.sa-detail-section-header label {
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #a78bfa;
}
/* ── Tokens reveal (superadmin only) ── */
.sa-tokens-section {
    margin-top: 1.25rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(255, 0, 0, 0.18);
}

.sa-tokens-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
}

.sa-tokens-header h4 {
    margin: 0;
    color: #fca5a5;
    font-size: 0.95rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.sa-tokens-warning {
    margin: 0 0 0.75rem 0;
    padding: 0.5rem 0.75rem;
    background: rgba(239, 68, 68, 0.08);
    border: 1px solid rgba(239, 68, 68, 0.25);
    border-radius: 6px;
    color: #fecaca;
    font-size: 0.8rem;
}

.sa-btn-reveal-tokens {
    background: rgba(239, 68, 68, 0.15);
    border: 1px solid rgba(239, 68, 68, 0.4);
    color: #fecaca;
    padding: 0.4rem 0.85rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 600;
}

.sa-btn-reveal-tokens:hover {
    background: rgba(239, 68, 68, 0.25);
}

.sa-tokens-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
}

.sa-token-field {
    grid-column: 1 / -1;
}

.sa-token-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.25rem;
}

.sa-token-value {
    flex: 1 1;
    padding: 0.5rem 0.75rem;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 6px;
    font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
    font-size: 0.78rem;
    color: #e5e7eb;
    word-break: break-all;
    overflow-x: auto;
    white-space: nowrap;
}

.sa-token-btn {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #e5e7eb;
    padding: 0.4rem 0.7rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.8rem;
    white-space: nowrap;
}

.sa-token-btn:hover {
    background: rgba(255, 255, 255, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/SocialAccounts.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;IACI,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,+BAA+B;AAC/B;IACI,8CAA8C;IAC9C,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iDAAiD;AACjD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;AACA,0CAA0C;AAC1C;IACI,mBAAmB;IACnB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,yDAAyD;IACzD,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["/* SocialAccounts admin page styles */\n\n.social-accounts-page {\n    padding: 0;\n}\n\n/* ── Header ── */\n.sa-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n}\n\n.sa-header h1 {\n    margin: 0;\n}\n\n.sa-btn-refresh {\n    padding: 0.5rem 1rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 0.85rem;\n    transition: background 0.15s;\n}\n\n.sa-btn-refresh:hover {\n    background: #f1f5f9;\n}\n\n/* ── Platform Tabs ── */\n.sa-platform-tabs {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 1.25rem;\n    border-bottom: 2px solid #e2e8f0;\n    padding-bottom: 0;\n}\n\n.sa-platform-tab {\n    padding: 0.6rem 1.25rem;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: #64748b;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -2px;\n    transition: color 0.15s, border-color 0.15s;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.sa-platform-tab:hover {\n    color: #1e293b;\n}\n\n.sa-platform-tab-active {\n    color: #3b82f6;\n    border-bottom-color: #3b82f6;\n    font-weight: 600;\n}\n\n.sa-tab-count {\n    background: #f1f5f9;\n    color: #475569;\n    font-size: 0.75rem;\n    padding: 0.1rem 0.5rem;\n    border-radius: 10px;\n    font-weight: 600;\n}\n\n.sa-platform-tab-active .sa-tab-count {\n    background: #dbeafe;\n    color: #2563eb;\n}\n\n/* ── Stats row ── */\n.sa-stats-row {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.sa-stat-card {\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 1.25rem;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.sa-stat-value {\n    font-size: 1.8rem;\n    font-weight: 700;\n    color: #1e293b;\n}\n\n.sa-stat-label {\n    font-size: 0.8rem;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.sa-stat-active .sa-stat-value {\n    color: #16a34a;\n}\n\n.sa-stat-expired .sa-stat-value {\n    color: #dc2626;\n}\n\n.sa-stat-notoken .sa-stat-value {\n    color: #94a3b8;\n}\n\n/* ── Filters ── */\n.sa-filters {\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 1.25rem;\n    flex-wrap: wrap;\n}\n\n.sa-search-input {\n    flex: 1;\n    min-width: 200px;\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 0.9rem;\n}\n\n.sa-search-input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 2px rgba(59, 130, 246, .15);\n}\n\n.sa-select {\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    background: #fff;\n    min-width: 150px;\n}\n\n/* ── Table ── */\n.sa-table-container {\n    background: #fff;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    overflow-x: auto;\n}\n\n.sa-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.9rem;\n}\n\n.sa-table thead th {\n    text-align: left;\n    padding: 0.75rem 1rem;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n    color: #475569;\n    font-weight: 600;\n    font-size: 0.8rem;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    white-space: nowrap;\n}\n\n.sa-table tbody td {\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid #f1f5f9;\n    vertical-align: middle;\n}\n\n.sa-row-clickable {\n    cursor: pointer;\n    transition: background 0.12s;\n}\n\n.sa-row-clickable:hover {\n    background: #f8fafc;\n}\n\n.sa-user-email {\n    font-size: 0.85rem;\n    color: #475569;\n}\n\n.sa-username-cell {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.sa-profile-pic {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.sa-avatar-fallback {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    color: #fff;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75rem;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.sa-detail-avatar-fallback {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    color: #fff;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n    font-weight: 700;\n    flex-shrink: 0;\n    border: 2px solid #e2e8f0;\n}\n\n.sa-hidden {\n    display: none !important;\n}\n\n/* ── Badges ── */\n.sa-badge {\n    display: inline-block;\n    padding: 0.2rem 0.6rem;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.sa-badge-connected {\n    background: #d1fae5;\n    color: #065f46;\n}\n\n.sa-badge-expired {\n    background: #fee2e2;\n    color: #991b1b;\n}\n\n.sa-badge-notoken {\n    background: #f1f5f9;\n    color: #64748b;\n}\n\n/* ── Pagination ── */\n.sa-pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 1.25rem;\n}\n\n.sa-pagination button {\n    padding: 0.4rem 0.9rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 0.85rem;\n}\n\n.sa-pagination button:disabled {\n    opacity: 0.45;\n    cursor: default;\n}\n\n.sa-page-info {\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n/* ── States ── */\n.sa-loading,\n.sa-empty {\n    text-align: center;\n    padding: 3rem 1rem;\n    color: #64748b;\n    font-size: 0.95rem;\n}\n\n.sa-error {\n    background: #fef2f2;\n    color: #b91c1c;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n}\n\n/* ── Detail Modal ── */\n.sa-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    padding: 1rem;\n}\n\n.sa-modal-card {\n    background: #fff;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.sa-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.25rem 1.5rem;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.sa-modal-header h2 {\n    margin: 0;\n    font-size: 1.1rem;\n}\n\n.sa-modal-close {\n    background: none;\n    border: none;\n    font-size: 1.2rem;\n    cursor: pointer;\n    color: #64748b;\n    padding: 0.25rem;\n}\n\n.sa-modal-body {\n    padding: 1.5rem;\n}\n\n.sa-detail-row {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.sa-detail-avatar {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid #e2e8f0;\n}\n\n.sa-detail-row h3 {\n    margin: 0;\n}\n\n.sa-detail-name {\n    margin: 0.25rem 0 0;\n    color: #64748b;\n    font-size: 0.9rem;\n}\n\n.sa-detail-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n}\n\n.sa-detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n}\n\n.sa-detail-item label {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.sa-detail-item span {\n    font-size: 0.9rem;\n    color: #1e293b;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n    .sa-stats-row {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .sa-detail-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 480px) {\n    .sa-stats-row {\n        grid-template-columns: 1fr;\n    }\n\n    .sa-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.75rem;\n    }\n\n    .sa-platform-tabs {\n        overflow-x: auto;\n    }\n}\n\n/* ── TikTok Detail extras ── */\n.sa-mono {\n    font-family: 'SF Mono', 'Fira Code', monospace;\n    font-size: 0.8rem;\n    word-break: break-all;\n}\n\n.sa-detail-full-width {\n    grid-column: 1 / -1;\n}\n\n.sa-tiktok-link {\n    color: #3b82f6;\n    text-decoration: none;\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n.sa-tiktok-link:hover {\n    text-decoration: underline;\n}\n\n/* Business API section header in TikTok detail */\n.sa-detail-section-header {\n    margin-top: 0.75rem;\n    padding-top: 0.75rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.sa-detail-section-header label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #a78bfa;\n}\n/* ── Tokens reveal (superadmin only) ── */\n.sa-tokens-section {\n    margin-top: 1.25rem;\n    padding-top: 1rem;\n    border-top: 1px solid rgba(255, 0, 0, 0.18);\n}\n\n.sa-tokens-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 0.5rem;\n}\n\n.sa-tokens-header h4 {\n    margin: 0;\n    color: #fca5a5;\n    font-size: 0.95rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.sa-tokens-warning {\n    margin: 0 0 0.75rem 0;\n    padding: 0.5rem 0.75rem;\n    background: rgba(239, 68, 68, 0.08);\n    border: 1px solid rgba(239, 68, 68, 0.25);\n    border-radius: 6px;\n    color: #fecaca;\n    font-size: 0.8rem;\n}\n\n.sa-btn-reveal-tokens {\n    background: rgba(239, 68, 68, 0.15);\n    border: 1px solid rgba(239, 68, 68, 0.4);\n    color: #fecaca;\n    padding: 0.4rem 0.85rem;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.sa-btn-reveal-tokens:hover {\n    background: rgba(239, 68, 68, 0.25);\n}\n\n.sa-tokens-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n}\n\n.sa-token-field {\n    grid-column: 1 / -1;\n}\n\n.sa-token-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 0.25rem;\n}\n\n.sa-token-value {\n    flex: 1;\n    padding: 0.5rem 0.75rem;\n    background: rgba(0, 0, 0, 0.35);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 6px;\n    font-family: 'SFMono-Regular', Menlo, Consolas, monospace;\n    font-size: 0.78rem;\n    color: #e5e7eb;\n    word-break: break-all;\n    overflow-x: auto;\n    white-space: nowrap;\n}\n\n.sa-token-btn {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    color: #e5e7eb;\n    padding: 0.4rem 0.7rem;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.8rem;\n    white-space: nowrap;\n}\n\n.sa-token-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
